(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-ambassador"]) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('[data-ql-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ql-revealed'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ql-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-collection"]) return;
  try {
    
  (function () {
    function initReveal() {
      var els = document.querySelectorAll('[data-ql-reveal]:not(.ql-revealed)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('ql-revealed'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ql-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      els.forEach(function (el) { observer.observe(el); });
      setTimeout(function () {
        els.forEach(function (el) { el.classList.add('ql-revealed'); });
      }, 1200);
    }

    initReveal();
    document.addEventListener('shopify:section:load', initReveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ql-home"]) return;
  try {
    
  (function () {
    function initReveal() {
      var els = document.querySelectorAll('[data-ql-reveal]:not(.ql-revealed)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('ql-revealed'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('ql-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      els.forEach(function (el) { observer.observe(el); });
      setTimeout(function () {
        els.forEach(function (el) { el.classList.add('ql-revealed'); });
      }, 1200);
    }
    initReveal();
    document.addEventListener('shopify:section:load', initReveal);
  })();

  } catch(e) { console.error(e); }
})();
})();
